import { IAuthStore } from './auth.interface';

export const EMPTY_TOKEN_STUB = '.e30';
export const STORAGE_KEY_TOKEN = 'token';
export const STORAGE_KEY_REFRESH_TOKEN = 'refreshToken';

export const LOGIN_URL = '/login';
export const LOGOUT_URL = '/logout';
export const GET_TOKEN_URL = '/api/v1/auth/token';

export const MASTER_REALM = 'master';

/**
 * Timer-driven token refresh (keycloak-js `onTokenExpired`) retry policy. keycloak-js does not
 * re-arm its expiry timer after a failed refresh, so a transient failure must be retried here or
 * the session silently stops refreshing until the next 401. Definitive failures (400/401/403)
 * skip the retries and end the session (LB-2552).
 */
export const REFRESH_MAX_RETRIES = 3;
export const REFRESH_RETRY_DELAYS_MS = [2000, 5000, 10000];

export const authInitialState: IAuthStore = {
  isAuthenticated: false,
};
